(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  ready(() => {
    const menuButton = document.querySelector('[data-menu-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    if (menuButton && mobileMenu) {
      menuButton.addEventListener('click', () => {
        const open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        mobileMenu.hidden = open;
      });
    }

    const sort = document.querySelector('[data-sort-by]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });

    const variantSelect = document.querySelector('[data-variant-select]');
    if (variantSelect) variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const price = document.querySelector('[data-product-price]');
      const compare = document.querySelector('[data-product-compare]');
      const sale = document.querySelector('[data-product-sale]');
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = option.dataset.hasCompare !== 'true';
      }
      if (sale) sale.hidden = option.dataset.hasCompare !== 'true';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });

    initMaterials();
    initConfigurator();
    initProductGalleries();
  });

  function initProductGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
      const main = gallery.querySelector('[data-gallery-main]');
      const current = gallery.querySelector('[data-gallery-current]');
      const previous = gallery.querySelector('[data-gallery-previous]');
      const next = gallery.querySelector('[data-gallery-next]');
      const zoom = gallery.querySelector('[data-gallery-zoom]');
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
      const close = gallery.querySelector('[data-gallery-close]');
      const lightboxPrevious = gallery.querySelector('[data-gallery-lightbox-previous]');
      const lightboxNext = gallery.querySelector('[data-gallery-lightbox-next]');
      const dialogCurrent = gallery.querySelector('[data-gallery-dialog-current]');
      const stage = gallery.querySelector('.product-stage__frame');
      if (!thumbnails.length || !main) return;

      let activeIndex = Math.max(0, thumbnails.findIndex(button => button.classList.contains('is-active')));
      let selectionVersion = 0;

      function updateImage(image, source, alt) {
        if (!image || !source) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = source;
        image.alt = alt;
      }

      function selectImage(index, focusThumbnail = false) {
        activeIndex = (index + thumbnails.length) % thumbnails.length;
        const button = thumbnails[activeIndex];
        const source = button.dataset.src;
        const zoomSource = button.dataset.zoomSrc || source;
        const alt = button.dataset.alt || '';
        const version = ++selectionVersion;
        main.classList.add('is-changing');
        updateImage(main, source, alt);
        updateImage(dialogImage, zoomSource, alt);

        const revealSelectedImage = () => {
          if (version !== selectionVersion) return;
          requestAnimationFrame(() => main.classList.remove('is-changing'));
        };
        if (typeof main.decode === 'function') main.decode().then(revealSelectedImage).catch(revealSelectedImage);
        else if (main.complete) revealSelectedImage();
        else main.addEventListener('load', revealSelectedImage, { once: true });

        thumbnails.forEach((item, itemIndex) => {
          const selected = itemIndex === activeIndex;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
        });
        if (current) current.textContent = String(activeIndex + 1);
        if (dialogCurrent) dialogCurrent.textContent = String(activeIndex + 1);
        if (focusThumbnail) button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      thumbnails.forEach((button, index) => button.addEventListener('click', event => {
        event.preventDefault();
        selectImage(index);
      }));
      const zoomWrap = gallery.querySelector('[data-gallery-zoom-wrap]');

      const openLightbox = () => {
        if (!dialog) return;
        const button = thumbnails[activeIndex];
        updateImage(dialogImage, button.dataset.zoomSrc || button.dataset.src, button.dataset.alt || '');
        zoomWrap?.classList.remove('is-zoomed');
        document.body.style.overflow = 'hidden';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      };

      const closeLightbox = () => {
        zoomWrap?.classList.remove('is-zoomed');
        document.body.style.overflow = '';
        if (typeof dialog?.close === 'function') dialog.close();
        else dialog?.removeAttribute('open');
      };

      dialogImage?.addEventListener('click', (e) => {
        e.stopPropagation();
        zoomWrap?.classList.toggle('is-zoomed');
      });

      previous?.addEventListener('click', () => selectImage(activeIndex - 1, true));
      next?.addEventListener('click', () => selectImage(activeIndex + 1, true));
      lightboxPrevious?.addEventListener('click', (e) => { e.stopPropagation(); selectImage(activeIndex - 1, true); });
      lightboxNext?.addEventListener('click', (e) => { e.stopPropagation(); selectImage(activeIndex + 1, true); });
      main.addEventListener('click', openLightbox);
      zoom?.addEventListener('click', openLightbox);
      close?.addEventListener('click', closeLightbox);
      dialog?.addEventListener('click', event => {
        if (
          event.target === dialogImage ||
          event.target.closest('[data-gallery-lightbox-previous]') ||
          event.target.closest('[data-gallery-lightbox-next]') ||
          event.target.closest('.product-lightbox__counter')
        ) {
          return;
        }
        closeLightbox();
      });
      dialog?.addEventListener('close', () => {
        document.body.style.overflow = '';
        zoomWrap?.classList.remove('is-zoomed');
      });
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          selectImage(activeIndex - 1, true);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          selectImage(activeIndex + 1, true);
        }
      });

      let touchStartX = null;
      stage?.addEventListener('touchstart', event => {
        touchStartX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });
      stage?.addEventListener('touchend', event => {
        if (touchStartX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 45) return;
        selectImage(activeIndex + (distance < 0 ? 1 : -1), true);
      }, { passive: true });
      selectImage(activeIndex);
    });
  }

  function initMaterials() {
    const browser = document.querySelector('[data-material-browser]');
    if (!browser) return;
    const tabs = [...browser.querySelectorAll('[data-stone]')];
    const texture = browser.querySelector('[data-material-texture]');
    const sphere = browser.querySelector('[data-material-sphere]');
    const title = browser.querySelector('[data-material-title]');
    const origin = browser.querySelector('[data-material-origin]');
    const tone = browser.querySelector('[data-material-tone]');
    const description = browser.querySelector('[data-material-description]');
    const stoneClasses = tabs.map(tab => `stone-${tab.dataset.stone}`);

    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(item => {
        item.classList.toggle('is-active', item === tab);
        item.setAttribute('aria-selected', String(item === tab));
      });
      if (texture) {
        texture.classList.remove(...stoneClasses);
        texture.classList.add(`stone-${tab.dataset.stone}`);
      }
      if (sphere) {
        sphere.classList.remove(...stoneClasses);
        sphere.classList.add(`stone-${tab.dataset.stone}`);
      }
      title.textContent = tab.dataset.title;
      origin.textContent = tab.dataset.origin;
      tone.textContent = tab.dataset.tone;
      description.textContent = tab.dataset.description;
      if (window.innerWidth < 801 && texture) texture.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
  }

  function initConfigurator() {
    const root = document.querySelector('[data-configurator]');
    if (!root || root.classList.contains('ncm-custom-page')) return;
    const form = root.querySelector('#CustomOrderForm');
    const preview = root.querySelector('[data-preview]');
    const stoneChoices = [...root.querySelectorAll('input[name="contact[Material]"]')];
    const unitButtons = [...root.querySelectorAll('[data-unit]')];
    const dimensions = [...root.querySelectorAll('[data-dimension]')];
    const widthInput = root.querySelector('[data-dimension="width"]');
    const depthInput = root.querySelector('[data-dimension="depth"]');
    const heightInput = root.querySelector('[data-dimension="height"]');
    const backsplashInput = root.querySelector('[data-dimension="backsplash"]');
    const installation = root.querySelector('select[name="contact[Installation]"]');
    const bowl = root.querySelector('[data-bowl]');
    const finish = root.querySelector('[data-finish]');
    const backsplashRadios = [...root.querySelectorAll('[data-backsplash]')];
    const previewBacksplash = root.querySelector('[data-preview-backsplash]');
    const previewFlutes = root.querySelector('[data-preview-flutes]');
    const fileInput = root.querySelector('[data-file-input]');
    let unit = 'in';

    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    const checked = name => root.querySelector(`input[name="${name}"]:checked`);
    const val = input => Number.parseFloat(input.value) || 0;
    const labelForValue = value => unit === 'in' ? round(value, 1) : round(value, 0);

    function round(number, precision) {
      const factor = 10 ** precision;
      return Math.round(number * factor) / factor;
    }

    function updatePreview() {
      const material = checked('contact[Material]');
      const materialHandle = material?.closest('[data-material-choice]')?.dataset.materialChoice || 'calacatta-viola';
      [...preview.classList].filter(name => name.startsWith('stone-')).forEach(name => preview.classList.remove(name));
      preview.classList.add(`stone-${materialHandle}`);

      root.querySelector('[data-summary-material]').textContent = material?.value || 'Not selected';
      const summarySwatch = root.querySelector('[data-summary-swatch]');
      if (summarySwatch) {
        [...summarySwatch.classList].filter(name => name.startsWith('stone-')).forEach(name => summarySwatch.classList.remove(name));
        summarySwatch.classList.add(`stone-${materialHandle}`);
      }
      root.querySelector('[data-preview-width]').textContent = labelForValue(val(widthInput));
      root.querySelector('[data-preview-depth]').textContent = labelForValue(val(depthInput));
      root.querySelector('[data-preview-height]').textContent = labelForValue(val(heightInput));
      root.querySelectorAll('[data-preview-unit]').forEach(node => node.textContent = unit);
      root.querySelector('[data-summary-dimensions]').textContent = `${labelForValue(val(widthInput))} × ${labelForValue(val(depthInput))} × ${labelForValue(val(heightInput))} ${unit}`;
      root.querySelector('[data-summary-installation]').textContent = installation.value;
      root.querySelector('[data-summary-finish]').textContent = finish.options[finish.selectedIndex].text;

      const hasBacksplash = checked('contact[Backsplash]')?.value === 'Yes';
      previewBacksplash.hidden = !hasBacksplash;
      backsplashInput.closest('.backsplash-height').hidden = !hasBacksplash;
      previewFlutes.hidden = finish.value !== 'fluted' && finish.value !== 'ribbed';

      const hole = preview.querySelector('.basin-hole');
      if (bowl.value === 'round') { hole.setAttribute('rx', '75'); hole.setAttribute('ry', '28'); }
      else if (bowl.value === 'angular') { hole.setAttribute('rx', '135'); hole.setAttribute('ry', '18'); }
      else if (bowl.value === 'rectangle') { hole.setAttribute('rx', '160'); hole.setAttribute('ry', '25'); }
      else { hole.setAttribute('rx', '148'); hole.setAttribute('ry', '22'); }

      const inchesWidth = unit === 'cm' ? val(widthInput) / 2.54 : val(widthInput);
      const inchesDepth = unit === 'cm' ? val(depthInput) / 2.54 : val(depthInput);
      const inchesHeight = unit === 'cm' ? val(heightInput) / 2.54 : val(heightInput);
      const materialFactor = { 'calacatta-viola': 1.34, 'calacatta-gold': 1.26, 'nero-marquina': 1.1, travertine: .9, 'red-travertine': 1.03, 'afyon-grey': .95, emperador: 1.05, lilac: 1.16, 'bayat-black': 1.08, 'elazig-cherry': 1.18, other: 1.08 }[materialHandle] || 1;
      const finishFactor = finish.value === 'fluted' ? 1.15 : finish.value === 'ribbed' ? 1.12 : finish.value === 'raw' ? 1.08 : 1;
      const backsplashCost = hasBacksplash ? 180 + (unit === 'cm' ? val(backsplashInput) / 2.54 : val(backsplashInput)) * 16 : 0;
      const estimate = Math.max(1450, 1080 + inchesWidth * inchesDepth * .9 + inchesHeight * 38 + backsplashCost) * materialFactor * finishFactor;
      root.querySelector('[data-estimate]').textContent = money.format(Math.round(estimate / 10) * 10);
      updateSummaryField();
    }

    function updateSummaryField() {
      const material = checked('contact[Material]')?.value || 'Not selected';
      const backsplash = checked('contact[Backsplash]')?.value || 'No';
      root.querySelector('[data-summary-field]').value = [
        `Material: ${material}`,
        `Dimensions: ${widthInput.value} × ${depthInput.value} × ${heightInput.value} ${unit}`,
        `Backsplash: ${backsplash}${backsplash === 'Yes' ? `, ${backsplashInput.value} ${unit} high` : ''}`,
        `Installation: ${installation.value}`,
        `Bowl: ${bowl.options[bowl.selectedIndex].text}`,
        `Front: ${finish.options[finish.selectedIndex].text}`
      ].join(' | ');
    }

    unitButtons.forEach(button => button.addEventListener('click', () => {
      if (button.dataset.unit === unit) return;
      const toCm = button.dataset.unit === 'cm';
      dimensions.forEach(input => input.value = toCm ? round(val(input) * 2.54, 1) : round(val(input) / 2.54, 1));
      unit = button.dataset.unit;
      unitButtons.forEach(item => item.classList.toggle('is-active', item === button));
      root.querySelectorAll('[data-unit-label]').forEach(label => label.textContent = unit);
      updatePreview();
    }));

    [...stoneChoices, ...dimensions, ...backsplashRadios].forEach(input => input.addEventListener('input', updatePreview));
    [installation, bowl, finish].forEach(input => input.addEventListener('change', updatePreview));

    if (fileInput) fileInput.addEventListener('change', () => {
      const names = [...fileInput.files].map(file => file.name);
      root.querySelector('[data-file-label]').textContent = names.length ? names.join(', ') : 'No files selected';
      root.querySelector('[data-file-summary]').value = names.join(', ');
    });
    form.addEventListener('submit', updateSummaryField);
    updatePreview();
  }
})();
